import React from "react";
import { Scrollbars } from "react-custom-scrollbars";

export function VerticalsLegend({ verticals, hideDefault = false }) {
  if (!verticals?.length) {
    return null;
  }

  return (
    <div className="sidebarSectionContainer">
      <h3 className="sidebarHeading">Verticals</h3>
      <Scrollbars
        autoHeight
        autoHeightMin={0}
        autoHeightMax={188}
        className="full-width"
        renderTrackHorizontal={(props) => (
          <div
            {...props}
            style={{ display: "none" }}
            className="track-horizontal"
          />
        )}
      >
        <ul>
          {verticals.map((vertical) => {
            if (hideDefault && !vertical.id) {
              return null;
            }

            return (
              <li className="verticalsLegendItem" key={vertical.id}>
                <div
                  style={{
                    backgroundColor: vertical.color,
                  }}
                  className="verticalsLegendIndicator"
                />
                <div className="sidebarItemName">{vertical.name}</div>
              </li>
            );
          })}
        </ul>
      </Scrollbars>
    </div>
  );
}
